// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   LinkedIn-Style Bottom-Right Docked Live Chat Widget - Admin Portal
   ========================================================================== */

.admin-li-chat-wrapper {
    position: fixed;
    bottom: 0;
    right: 72px;
    z-index: 99999;
    display: flex;
    align-items: flex-end;
    gap: 14px;
    pointer-events: none;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.admin-li-chat-wrapper > * {
    pointer-events: auto;
}

/* ==========================================================================
   1. Floating Chat Icon Button on Bottom Right (Admin Portal)
   ========================================================================== */
.admin-floating-chat-trigger {
    display: flex;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    margin-bottom: 20px;
}

.admin-chat-icon-btn {
    position: relative;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4), 0 8px 30px rgba(0, 0, 0, 0.15);
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.admin-floating-chat-trigger:hover .admin-chat-icon-btn {
    transform: scale(1.08) translateY(-2px);
    box-shadow: 0 8px 24px rgba(37, 99, 235, 0.5), 0 12px 35px rgba(0, 0, 0, 0.2);
}

.admin-chat-icon-main {
    font-size: 26px;
    line-height: 1;
}

.admin-chat-pulse-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid rgba(37, 99, 235, 0.6);
    animation: adminPulse 2.2s infinite;
    pointer-events: none;
}

@keyframes adminPulse {
    0% {
        transform: scale(0.95);
        opacity: 0.8;
    }
    70% {
        transform: scale(1.35);
        opacity: 0;
    }
    100% {
        transform: scale(1.35);
        opacity: 0;
    }
}

.admin-chat-badge-bubble {
    position: absolute;
    top: -2px;
    right: -2px;
    background: #ef4444;
    color: #ffffff;
    font-size: 11px;
    font-weight: 800;
    min-width: 21px;
    height: 21px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.5);
    animation: adminBadgePulse 1.8s infinite;
}

@keyframes adminBadgePulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.08);
    }
}

/* ==========================================================================
   2. Main Messaging Drawer (LinkedIn Conversations Hub)
   ========================================================================== */
.admin-li-drawer {
    width: 330px;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-bottom: none;
    border-radius: 12px 12px 0 0;
    box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 540px;
    max-height: calc(100vh - 40px);
    animation: adminLiTabSlide 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Drawer Header */
.admin-li-drawer-header {
    height: 50px;
    padding: 0 14px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}

.admin-li-drawer-title-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
}

.admin-li-drawer-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #1d4ed8);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
}

.admin-li-drawer-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 6px;
}

.admin-li-drawer-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.admin-li-badge-unread {
    background: #ef4444;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    min-width: 19px;
    height: 19px;
    padding: 0 5px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.4);
}

.admin-li-btn-toggle {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
}

/* Search Bar in Expanded Drawer */
.admin-li-search-box {
    padding: 8px 12px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.admin-li-search-box i {
    color: #94a3b8;
    font-size: 15px;
}

.admin-li-search-input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 13px;
    color: #1e293b;
    background: transparent;
}

.admin-li-search-input::placeholder {
    color: #94a3b8;
}

/* Conversations List */
.admin-li-conv-list {
    flex: 1 1;
    overflow-y: auto;
    background: #ffffff;
}

.admin-li-conv-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #f1f5f9;
    cursor: pointer;
    transition: background 0.15s ease;
    gap: 10px;
    position: relative;
}

.admin-li-conv-item:hover {
    background: #f8fafc;
}

.admin-li-conv-item.active {
    background: #eff6ff;
    border-left: 3px solid #2563eb;
}

.admin-li-conv-avatar-wrap {
    position: relative;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
}

.admin-li-conv-avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #e2e8f0;
    color: #475569;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.admin-li-conv-info {
    flex: 1 1;
    min-width: 0;
}

.admin-li-conv-top-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 2px;
}

.admin-li-client-name {
    font-size: 12.5px;
    font-weight: 700;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.admin-li-conv-time {
    font-size: 10px;
    color: #94a3b8;
    margin-left: 6px;
    flex-shrink: 0;
}

.admin-li-conv-sub-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.admin-li-snippet {
    font-size: 11.5px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
}

.admin-li-snippet.unread-bold {
    font-weight: 700;
    color: #0f172a;
}

.admin-li-conv-unread-pill {
    background: #2563eb;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    min-width: 17px;
    height: 17px;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    margin-left: 6px;
    flex-shrink: 0;
}

.admin-li-empty-convs {
    padding: 30px 20px;
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
}

/* ==========================================================================
   2. Active Chat Tab (Docked To Left of Drawer, LinkedIn Style)
   ========================================================================== */
.admin-li-chat-tab {
    width: 340px;
    height: 540px;
    max-height: calc(100vh - 40px);
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-bottom: none;
    border-radius: 12px 12px 0 0;
    box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: adminLiTabSlide 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    transition: width 0.2s ease, height 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.admin-li-chat-tab.minimized {
    width: 210px;
    height: 48px;
    cursor: pointer;
}

.admin-li-chat-tab.minimized:hover {
    background: #f8fafc;
    border-color: #94a3b8;
}

@keyframes adminLiTabSlide {
    from {
        opacity: 0;
        transform: translateY(15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Tab Header */
.admin-li-tab-header {
    height: 50px;
    padding: 0 12px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    cursor: pointer;
}

.admin-li-tab-client-info {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.admin-li-tab-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #3b82f6;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.admin-li-tab-names {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.admin-li-tab-name {
    font-size: 13.5px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.admin-li-tab-company {
    font-size: 11px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 1px;
}

.admin-li-tab-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.admin-li-tab-btn {
    background: transparent;
    border: none;
    color: #64748b;
    width: 26px;
    height: 26px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.admin-li-tab-btn:hover {
    background: #f1f5f9;
    color: #0f172a;
}

/* Message Thread Body */
.admin-li-tab-body {
    flex: 1 1;
    padding: 16px;
    overflow-y: auto;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    gap: 12px;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.admin-li-tab-body::-webkit-scrollbar,
.admin-li-conv-list::-webkit-scrollbar {
    width: 6px;
}

.admin-li-tab-body::-webkit-scrollbar-track,
.admin-li-conv-list::-webkit-scrollbar-track {
    background: transparent;
}

.admin-li-tab-body::-webkit-scrollbar-thumb,
.admin-li-conv-list::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 6px;
}

.admin-li-tab-body::-webkit-scrollbar-thumb:hover,
.admin-li-conv-list::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

.admin-li-tab-date-divider {
    text-align: center;
    margin: 4px 0;
}

.admin-li-tab-date-divider span {
    background: #e2e8f0;
    color: #64748b;
    font-size: 10.5px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 10px;
}

/* Message Bubbles */
.admin-li-msg {
    display: flex;
    gap: 10px;
    max-width: 82%;
}

.admin-li-msg.incoming {
    align-self: flex-start;
}

.admin-li-msg.outgoing {
    align-self: flex-end;
    flex-direction: row-reverse;
}

.admin-li-msg-bubble {
    padding: 11px 16px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}

.admin-li-msg.incoming .admin-li-msg-bubble {
    background: #ffffff;
    color: #1e293b;
    border: 1px solid #e2e8f0;
    border-top-left-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.admin-li-msg.outgoing .admin-li-msg-bubble {
    background: #2563eb;
    color: #ffffff;
    border-top-right-radius: 4px;
    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);
}

.admin-li-msg-meta {
    font-size: 9.5px;
    color: #94a3b8;
    margin-top: 3px;
    display: flex;
    align-items: center;
    gap: 3px;
}

.admin-li-msg.outgoing .admin-li-msg-meta {
    color: #64748b;
    justify-content: flex-end;
}

/* Attachments inside bubble */
.admin-li-attachments {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 6px;
}

.admin-li-att-img {
    max-width: 170px;
    max-height: 130px;
    border-radius: 6px;
    object-fit: cover;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.admin-li-att-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    border-radius: 5px;
    text-decoration: none;
    font-size: 11px;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.06);
    color: inherit;
}

.admin-li-msg.outgoing .admin-li-att-link {
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
}

/* Typing Bubble */
.admin-li-typing-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
    align-self: flex-start;
}

.admin-li-typing-bubble {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    padding: 6px 12px;
    border-radius: 12px;
    border-top-left-radius: 2px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.admin-li-dot {
    width: 5px;
    height: 5px;
    background: #94a3b8;
    border-radius: 50%;
    animation: adminLiDot 1.4s infinite ease-in-out both;
}

.admin-li-dot:nth-child(1) { animation-delay: -0.32s; }
.admin-li-dot:nth-child(2) { animation-delay: -0.16s; }

@keyframes adminLiDot {
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1); }
}

/* Chat Tab Footer Input */
.admin-li-tab-footer {
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    padding: 12px 16px;
    flex-shrink: 0;
}

.admin-li-selected-file-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    margin-bottom: 10px;
}

.admin-li-input-row {
    display: flex;
    align-items: flex-end;
    gap: 10px;
}

.admin-li-textarea {
    flex: 1 1;
    border: 1px solid #cbd5e1;
    border-radius: 20px;
    padding: 10px 16px;
    font-size: 14px;
    color: #1e293b;
    resize: none;
    outline: none;
    max-height: 100px;
    min-height: 42px;
    line-height: 1.45;
    transition: border-color 0.15s ease;
}

.admin-li-textarea:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.admin-li-btn-tool {
    background: transparent;
    border: none;
    color: #64748b;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.15s ease;
}

.admin-li-btn-tool:hover {
    background: #f1f5f9;
    color: #2563eb;
}

.admin-li-btn-send {
    background: #2563eb;
    border: none;
    color: #ffffff;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.15s ease;
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
}

.admin-li-btn-send:hover:not(:disabled) {
    background: #1d4ed8;
    transform: translateY(-1px);
}

.admin-li-btn-send:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
}

/* Responsive */
@media (max-width: 1400px) {
    .admin-li-chat-tab,
    .admin-li-drawer {
        width: 320px;
    }
}

@media (max-width: 1100px) {
    .admin-li-chat-tab,
    .admin-li-drawer {
        width: 300px;
    }
}

@media (max-width: 768px) {
    .admin-li-chat-wrapper {
        right: 8px;
        left: 8px;
        flex-direction: column-reverse;
        gap: 6px;
    }
    .admin-li-drawer,
    .admin-li-chat-tab {
        width: 100% !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/LinkedInChat/LinkedInChat.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,oBAAoB;IACpB,gGAAgG;AACpG;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;+EAE+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6EAA6E;IAC7E,mDAAmD;AACvD;;AAEA;IACI,uCAAuC;IACvC,6EAA6E;AACjF;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,4CAA4C;IAC5C,wCAAwC;AAC5C;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;+EAE+E;AAC/E;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,6DAA6D;AACjE;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iCAAiC;IACjC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;;+EAE+E;AAC/E;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,6DAA6D;IAC7D,sEAAsE;AAC1E;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;;AAEtD;IACI,gBAAgB,mBAAmB,EAAE;IACrC,MAAM,mBAAmB,EAAE;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,SAAS;QACT,8BAA8B;QAC9B,QAAQ;IACZ;IACA;;QAEI,sBAAsB;IAC1B;AACJ","sourcesContent":["/* ==========================================================================\n   LinkedIn-Style Bottom-Right Docked Live Chat Widget - Admin Portal\n   ========================================================================== */\n\n.admin-li-chat-wrapper {\n    position: fixed;\n    bottom: 0;\n    right: 72px;\n    z-index: 99999;\n    display: flex;\n    align-items: flex-end;\n    gap: 14px;\n    pointer-events: none;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.admin-li-chat-wrapper > * {\n    pointer-events: auto;\n}\n\n/* ==========================================================================\n   1. Floating Chat Icon Button on Bottom Right (Admin Portal)\n   ========================================================================== */\n.admin-floating-chat-trigger {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    margin-bottom: 20px;\n}\n\n.admin-chat-icon-btn {\n    position: relative;\n    width: 58px;\n    height: 58px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4), 0 8px 30px rgba(0, 0, 0, 0.15);\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.admin-floating-chat-trigger:hover .admin-chat-icon-btn {\n    transform: scale(1.08) translateY(-2px);\n    box-shadow: 0 8px 24px rgba(37, 99, 235, 0.5), 0 12px 35px rgba(0, 0, 0, 0.2);\n}\n\n.admin-chat-icon-main {\n    font-size: 26px;\n    line-height: 1;\n}\n\n.admin-chat-pulse-ring {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 2px solid rgba(37, 99, 235, 0.6);\n    animation: adminPulse 2.2s infinite;\n    pointer-events: none;\n}\n\n@keyframes adminPulse {\n    0% {\n        transform: scale(0.95);\n        opacity: 0.8;\n    }\n    70% {\n        transform: scale(1.35);\n        opacity: 0;\n    }\n    100% {\n        transform: scale(1.35);\n        opacity: 0;\n    }\n}\n\n.admin-chat-badge-bubble {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    background: #ef4444;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 800;\n    min-width: 21px;\n    height: 21px;\n    border-radius: 11px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 5px;\n    border: 2px solid #ffffff;\n    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.5);\n    animation: adminBadgePulse 1.8s infinite;\n}\n\n@keyframes adminBadgePulse {\n    0%, 100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.08);\n    }\n}\n\n/* ==========================================================================\n   2. Main Messaging Drawer (LinkedIn Conversations Hub)\n   ========================================================================== */\n.admin-li-drawer {\n    width: 330px;\n    background: #ffffff;\n    border: 1px solid #cbd5e1;\n    border-bottom: none;\n    border-radius: 12px 12px 0 0;\n    box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    height: 540px;\n    max-height: calc(100vh - 40px);\n    animation: adminLiTabSlide 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Drawer Header */\n.admin-li-drawer-header {\n    height: 50px;\n    padding: 0 14px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n    user-select: none;\n    cursor: pointer;\n}\n\n.admin-li-drawer-title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.admin-li-drawer-avatar {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.admin-li-drawer-title {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #0f172a;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.admin-li-drawer-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.admin-li-badge-unread {\n    background: #ef4444;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 700;\n    min-width: 19px;\n    height: 19px;\n    padding: 0 5px;\n    border-radius: 10px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.4);\n}\n\n.admin-li-btn-toggle {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    font-size: 16px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n}\n\n/* Search Bar in Expanded Drawer */\n.admin-li-search-box {\n    padding: 8px 12px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.admin-li-search-box i {\n    color: #94a3b8;\n    font-size: 15px;\n}\n\n.admin-li-search-input {\n    width: 100%;\n    border: none;\n    outline: none;\n    font-size: 13px;\n    color: #1e293b;\n    background: transparent;\n}\n\n.admin-li-search-input::placeholder {\n    color: #94a3b8;\n}\n\n/* Conversations List */\n.admin-li-conv-list {\n    flex: 1;\n    overflow-y: auto;\n    background: #ffffff;\n}\n\n.admin-li-conv-item {\n    display: flex;\n    align-items: center;\n    padding: 10px 12px;\n    border-bottom: 1px solid #f1f5f9;\n    cursor: pointer;\n    transition: background 0.15s ease;\n    gap: 10px;\n    position: relative;\n}\n\n.admin-li-conv-item:hover {\n    background: #f8fafc;\n}\n\n.admin-li-conv-item.active {\n    background: #eff6ff;\n    border-left: 3px solid #2563eb;\n}\n\n.admin-li-conv-avatar-wrap {\n    position: relative;\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n}\n\n.admin-li-conv-avatar {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background: #e2e8f0;\n    color: #475569;\n    font-size: 12px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.admin-li-conv-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.admin-li-conv-top-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    margin-bottom: 2px;\n}\n\n.admin-li-client-name {\n    font-size: 12.5px;\n    font-weight: 700;\n    color: #0f172a;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.admin-li-conv-time {\n    font-size: 10px;\n    color: #94a3b8;\n    margin-left: 6px;\n    flex-shrink: 0;\n}\n\n.admin-li-conv-sub-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.admin-li-snippet {\n    font-size: 11.5px;\n    color: #64748b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin: 0;\n}\n\n.admin-li-snippet.unread-bold {\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.admin-li-conv-unread-pill {\n    background: #2563eb;\n    color: #ffffff;\n    font-size: 10px;\n    font-weight: 700;\n    min-width: 17px;\n    height: 17px;\n    border-radius: 9px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 4px;\n    margin-left: 6px;\n    flex-shrink: 0;\n}\n\n.admin-li-empty-convs {\n    padding: 30px 20px;\n    text-align: center;\n    color: #94a3b8;\n    font-size: 13px;\n}\n\n/* ==========================================================================\n   2. Active Chat Tab (Docked To Left of Drawer, LinkedIn Style)\n   ========================================================================== */\n.admin-li-chat-tab {\n    width: 340px;\n    height: 540px;\n    max-height: calc(100vh - 40px);\n    background: #ffffff;\n    border: 1px solid #cbd5e1;\n    border-bottom: none;\n    border-radius: 12px 12px 0 0;\n    box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: adminLiTabSlide 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    transition: width 0.2s ease, height 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.admin-li-chat-tab.minimized {\n    width: 210px;\n    height: 48px;\n    cursor: pointer;\n}\n\n.admin-li-chat-tab.minimized:hover {\n    background: #f8fafc;\n    border-color: #94a3b8;\n}\n\n@keyframes adminLiTabSlide {\n    from {\n        opacity: 0;\n        transform: translateY(15px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Tab Header */\n.admin-li-tab-header {\n    height: 50px;\n    padding: 0 12px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n    cursor: pointer;\n}\n\n.admin-li-tab-client-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n}\n\n.admin-li-tab-avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: #3b82f6;\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.admin-li-tab-names {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.admin-li-tab-name {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.admin-li-tab-company {\n    font-size: 11px;\n    color: #64748b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-top: 1px;\n}\n\n.admin-li-tab-actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.admin-li-tab-btn {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    width: 26px;\n    height: 26px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.admin-li-tab-btn:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n/* Message Thread Body */\n.admin-li-tab-body {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n    background: #f8fafc;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e1 transparent;\n}\n\n.admin-li-tab-body::-webkit-scrollbar,\n.admin-li-conv-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.admin-li-tab-body::-webkit-scrollbar-track,\n.admin-li-conv-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.admin-li-tab-body::-webkit-scrollbar-thumb,\n.admin-li-conv-list::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 6px;\n}\n\n.admin-li-tab-body::-webkit-scrollbar-thumb:hover,\n.admin-li-conv-list::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n}\n\n.admin-li-tab-date-divider {\n    text-align: center;\n    margin: 4px 0;\n}\n\n.admin-li-tab-date-divider span {\n    background: #e2e8f0;\n    color: #64748b;\n    font-size: 10.5px;\n    font-weight: 600;\n    padding: 2px 10px;\n    border-radius: 10px;\n}\n\n/* Message Bubbles */\n.admin-li-msg {\n    display: flex;\n    gap: 10px;\n    max-width: 82%;\n}\n\n.admin-li-msg.incoming {\n    align-self: flex-start;\n}\n\n.admin-li-msg.outgoing {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n}\n\n.admin-li-msg-bubble {\n    padding: 11px 16px;\n    border-radius: 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    word-break: break-word;\n}\n\n.admin-li-msg.incoming .admin-li-msg-bubble {\n    background: #ffffff;\n    color: #1e293b;\n    border: 1px solid #e2e8f0;\n    border-top-left-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.admin-li-msg.outgoing .admin-li-msg-bubble {\n    background: #2563eb;\n    color: #ffffff;\n    border-top-right-radius: 4px;\n    box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);\n}\n\n.admin-li-msg-meta {\n    font-size: 9.5px;\n    color: #94a3b8;\n    margin-top: 3px;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n}\n\n.admin-li-msg.outgoing .admin-li-msg-meta {\n    color: #64748b;\n    justify-content: flex-end;\n}\n\n/* Attachments inside bubble */\n.admin-li-attachments {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 6px;\n}\n\n.admin-li-att-img {\n    max-width: 170px;\n    max-height: 130px;\n    border-radius: 6px;\n    object-fit: cover;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.admin-li-att-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 8px;\n    border-radius: 5px;\n    text-decoration: none;\n    font-size: 11px;\n    font-weight: 600;\n    background: rgba(0, 0, 0, 0.06);\n    color: inherit;\n}\n\n.admin-li-msg.outgoing .admin-li-att-link {\n    background: rgba(255, 255, 255, 0.2);\n    color: #ffffff;\n}\n\n/* Typing Bubble */\n.admin-li-typing-wrap {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    align-self: flex-start;\n}\n\n.admin-li-typing-bubble {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    padding: 6px 12px;\n    border-radius: 12px;\n    border-top-left-radius: 2px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.admin-li-dot {\n    width: 5px;\n    height: 5px;\n    background: #94a3b8;\n    border-radius: 50%;\n    animation: adminLiDot 1.4s infinite ease-in-out both;\n}\n\n.admin-li-dot:nth-child(1) { animation-delay: -0.32s; }\n.admin-li-dot:nth-child(2) { animation-delay: -0.16s; }\n\n@keyframes adminLiDot {\n    0%, 80%, 100% { transform: scale(0); }\n    40% { transform: scale(1); }\n}\n\n/* Chat Tab Footer Input */\n.admin-li-tab-footer {\n    background: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    padding: 12px 16px;\n    flex-shrink: 0;\n}\n\n.admin-li-selected-file-pill {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    padding: 6px 10px;\n    font-size: 12px;\n    margin-bottom: 10px;\n}\n\n.admin-li-input-row {\n    display: flex;\n    align-items: flex-end;\n    gap: 10px;\n}\n\n.admin-li-textarea {\n    flex: 1;\n    border: 1px solid #cbd5e1;\n    border-radius: 20px;\n    padding: 10px 16px;\n    font-size: 14px;\n    color: #1e293b;\n    resize: none;\n    outline: none;\n    max-height: 100px;\n    min-height: 42px;\n    line-height: 1.45;\n    transition: border-color 0.15s ease;\n}\n\n.admin-li-textarea:focus {\n    border-color: #2563eb;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);\n}\n\n.admin-li-btn-tool {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: all 0.15s ease;\n}\n\n.admin-li-btn-tool:hover {\n    background: #f1f5f9;\n    color: #2563eb;\n}\n\n.admin-li-btn-send {\n    background: #2563eb;\n    border: none;\n    color: #ffffff;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: all 0.15s ease;\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);\n}\n\n.admin-li-btn-send:hover:not(:disabled) {\n    background: #1d4ed8;\n    transform: translateY(-1px);\n}\n\n.admin-li-btn-send:disabled {\n    background: #cbd5e1;\n    cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 1400px) {\n    .admin-li-chat-tab,\n    .admin-li-drawer {\n        width: 320px;\n    }\n}\n\n@media (max-width: 1100px) {\n    .admin-li-chat-tab,\n    .admin-li-drawer {\n        width: 300px;\n    }\n}\n\n@media (max-width: 768px) {\n    .admin-li-chat-wrapper {\n        right: 8px;\n        left: 8px;\n        flex-direction: column-reverse;\n        gap: 6px;\n    }\n    .admin-li-drawer,\n    .admin-li-chat-tab {\n        width: 100% !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
